import { useLoader } from '@flash-global66/g-loader';

export default useLoader;
